import React, { useRef, useState } from 'react';
import PopoverMenu from '@Components/PopoverMenu/PopoverMenu';
import PopoverMenuItem from '@Components/PopoverMenu/PopoverMenuItem';
import DeleteProjectDialogue from '../ManageProject/DeleteProjectDialog';
import Styles from './ProjectCard.scss';

interface IProjectCardMenuProps {
    onDelete: () => void;
    onEditProjectName: () => void;
    projectName: string;
    isVisible: boolean;
    onCloseCallback: () => void;
    onOpenCallback: () => void;
    id?: string;
}

const ProjectCardMenu = (props: IProjectCardMenuProps) => {
    const {
        onDelete,
        onEditProjectName,
        projectName,
        isVisible,
        onCloseCallback,
        onOpenCallback,
        id,
    } = props;

    const [isDeleting, setIsDeleting] = useState<boolean>(false);
    const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] =
        useState<boolean>(false);
    const menuRef = useRef<PopoverMenu>();

    const handleDeleteProject = () => {
        setIsConfirmDeleteOpen(true);
    };

    const confirmDelete = () => {
        setIsDeleting(true);
        onDelete();
    };

    return (
        <div className={Styles.pcMenuContainer}>
            <PopoverMenu
                id={id}
                ref={menuRef}
                isHidden={!isVisible}
                onClose={onCloseCallback}
                btnContainerStyle={{ marginTop: '5px' }}
                onOpen={onOpenCallback}
            >
                <PopoverMenuItem
                    id={`${id}-rename`}
                    text="rename"
                    onClick={onEditProjectName}
                    parentRef={menuRef}
                />
                <PopoverMenuItem
                    id={`${id}-delete`}
                    text="delete"
                    onClick={handleDeleteProject}
                    parentRef={menuRef}
                />
            </PopoverMenu>
            <DeleteProjectDialogue
                isOpen={isConfirmDeleteOpen}
                onClose={() => setIsConfirmDeleteOpen(false)}
                isDeleting={isDeleting}
                onDelete={confirmDelete}
                projectName={projectName}
            />
        </div>
    );
};

export default ProjectCardMenu;
